module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.placeOrderRights) ? _c('section', {
    staticClass: "basket-order"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basket-order-nbItems"
  }, [_vm._v(_vm._s(_vm.datasListBaskets.nbItems) + " " + _vm._s(_vm.$t("basket.items")))]), _vm._v(" "), _c('div', {
    staticClass: "basket-order-finalPrice"
  }, [_c('span', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.$t("basket.subTotal")))]), _vm._v(" "), (_vm.datasListBaskets.currency.shortName) ? _c('span', {
    staticClass: "finalPrice"
  }, [_vm._v("\n            " + _vm._s(_vm._f("CurrencyCustomPipe")(_vm.displayRealPrice(_vm.datasListBaskets.finalPrice, _vm.getBasket.priceShown), "en-US", _vm.datasListBaskets.currency.shortName)) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "basket-order-detail"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("basket.noteBasket")))])]), _vm._v(" "), _c('div', {
    staticClass: "basket-order-action"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.validateBasket();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("basket.btnOrder")))])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-226625e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/basket/BasketOrder.vue
// module id = 3076
// module chunks = 0